export default {
  pageTitle: 'チューブ交換サービス',
  metaDescription: 'TEFは摩耗・損傷した熱交換器チューブを交換するチューブ交換サービスを提供し、熱性能を回復させ機器の寿命を延ばします。',
  sidebar: {
    heading: 'メンテナンス＆修繕一覧',
    weldingOverlay: '肉盛り溶接',
    patching: 'パッチ補修',
    piping: '配管',
    reshell: 'シェル取替え',
    retubing: 'チューブ取替え',
  },
  title: 'チューブ取替え',
  heading: '熱交換器チューブ取替え・交換サービス',
  paragraph1: '当社は、熱交換器における漏れの生じたチューブの取替え・交換を専門としており、最適な性能の確保と機器寿命の延長を実現します。設備の整った自社工場、またはお客様の現場のいずれでも対応可能であり、ダウンタイムを最小限に抑えた効率的な補修をご提供します。',
  paragraph2: '精度と品質を重視し、経験豊富な専門チームがチューブの抜き取りおよび取付けをスムーズに行い、熱交換器を最高の状態へと回復させます。定期メンテナンスから緊急補修まで、お客様のニーズに合わせた信頼性の高いソリューションをご提供いたします。',
  steps: {
    step1: 'チューブ分解',
    step2: 'チューブ洗浄',
    step3: '溶接部除去',
    step4: 'チューブ引抜き',
    step5: 'チューブ穴面取り',
    step6: 'チューブ溶接',
  },
};
